import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/msalConfig';
import App from './app/App';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/md-light-indigo/theme.css';
import './styles/global.scss';
const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event?.payload) {
            const result = event.payload;
            msalInstance.setActiveAccount(result.account);
        }
    });
    msalInstance.handleRedirectPromise({ navigateToLoginRequestUrl: false }).then((response) => {
        if (response?.account) {
            msalInstance.setActiveAccount(response.account);
            if (response.accessToken) {
                sessionStorage.setItem('microsoftAccessToken', response.accessToken);
            }
            if (response.idToken) {
                sessionStorage.setItem('microsoftIdToken', response.idToken);
            }
        }
    }).catch((err) => {
        console.error('MSAL redirect error:', err);
    });
    ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(PrimeReactProvider, { children: _jsx(MsalProvider, { instance: msalInstance, children: _jsx(App, {}) }) }) }));
});
